import React, { useEffect, useState } from 'react';
import './fInvoice.css'
import moment from 'moment';
import { numberWithCommas } from '../../../../../Utils/NumberToComma';
import _ from 'lodash'
import { post } from '../../../../../Model/Network/Config/Axios';
import { handleError, showToast } from '../../../../Common/fToast/ToastCallback';
import { useSelector } from 'react-redux';
import LineItemModal from './LineItemModal';
import { Modal } from '../../../../Common/fModal/Modal';
import AddLineItem from './AddLineItem';
import { useHistory } from 'react-router-dom';
import { sortAndMapForms } from '../India/fInvoice';

function Invoice(props) {
    let { invoiceStatus, enableLineItemPlugin ,systemInvoiceId,enableAddLineItem,vendorDetails} = props.data;
    const {disableUpdate,status} = props;
    let {searchProductByService,tdsAtLineItemAutomationV2,tdsAtLineItemAutomation,allowInvoiceAddLineItemAtDraft} = useSelector(state=>state.auth.config.plugins)
    const [showCustomFormId, setShowCustomFormId] = useState(false);
    const [showServiceCustomFormId, setShowServiceCustomFormId] = useState(false);
    const [edit, setEdit] = useState(undefined)
    const {tenant} = useSelector(state=>state.auth.config)
    let exclude=(tenant==="DEZ")
    const [remove, setRemove] = useState(undefined)
    const [addItem, setAddItem] = useState(false)
    const grnNo=props.data && props.data.grnNos && props.data.grnNos.length>0?(props.data.grnNos[0]) : props.details && props.details.grnId ? props.details.grnId : null
    const HISTORY = useHistory();
    const [rcLineItemTax,setRcLineItemTax] = useState({isRCItem:false,tax:0});
    const [show3WayMatchingMismatch, setShow3WayMatchingMismatch] = useState(false);

    // const rednerTable = (item, index) => {
    //     return (
    //         <div key={`entry-${index}`} style={{display: 'flex', justifyContent: 'space-evenly', margin: '15px 0px'}}>
    //             <div style={{width: '160px'}}>{item.desc}<br/>Code: {item.hsn}</div>
    //             <div style={{width: '100px',}}> {(item.price).toFixed(2)}</div>
    //             <div style={{width: '100px',}}>{item.qtty}</div>
    //             <div style={{width: '100px', textAlign: 'right'}}>{item.amount?item.amount.toFixed(2):null}</div>
    //         </div>
    //     )
    // }

    useEffect(()=>{
        if(props.data && props.data.table && props.data.table.length){
            let RCItem = false;
            let calcTax = 0;
            props.data.table.forEach(el =>{
                if(el.rcItem){
                    RCItem = true;
                    calcTax += el.tax_amt;
                }
            })
            setRcLineItemTax({isRCItem:RCItem,tax:calcTax});
        }
    },[props])

    const onSaveItem = (payload) => {
        if(payload && payload.tds && payload.tds.type && payload.tds.type==="master"){
            const { id ,tdsSlab} = payload.tds;
            delete payload.tds;
            payload["tds_master"] = id
            if(!tdsAtLineItemAutomationV2 && !tdsAtLineItemAutomation){
                payload.tdsSlab = tdsSlab;
            }
        }
        else if(payload && payload.tds){
            const { tdsSlab, tdsCode, tdsDesc } = payload.tds;
            delete payload.tds;
            payload.tdsSlab = tdsSlab;
            payload.tdsCode = tdsCode;
            payload.tdsDesc = tdsDesc;
        }
        post(`vendor/invoicing/${systemInvoiceId}/invoiceItem.update`,
            { ...payload },
            (e, r) => {
                if (r) {
                    props.onReload && props.onReload()
                    showToast({
                        type: 'success',
                        message: 'Line Item Updated Successfully'
                    })
                } else if (e) {
                    handleError(e)
                }
                setEdit(false)
            })
    }


    const onAddLineItem = (payload) =>{
       post(`vendor/invoicing/${systemInvoiceId}/invoiceItem.add`,
       {data:payload},
       (e,r) =>{
        if(r) {
            props.onReload();
            post(`vendor/costAllocation/removeAllocation`,{invoiceId:systemInvoiceId},(e,r)=>{
                if(r) {
                    props.onReload()
                } else {
                    props.onReload()
                }
            })
            showToast({
                type: 'success',
                message:'Line Item Added Successfully'
            })
        } else if(e){
           handleError(e)
        }
        setAddItem(false)
       })
    }

    const renderTable = (item, index)=>{
        return(
            <div key={`entry-${index}`} style={{display: 'flex', justifyContent: 'space-evenly', margin: '15px 0px'}}>
                <div style={{width: '160px'}}>
                    <b>{`${index+1}). `}</b>{item.desc}<br/>
                    {props.data.poNumber?`Item ref no :${item.referenceId}`:null} {props.data.poNumber?<br/>:null}
                    {item.orderId?`PO Number:${item.orderId}`:null} <br/>
                    Code: {item.hsn} <br /> 
                    Service : {item.service} <br></br>
                    {item.glCode ? <>GL Code : {item.glCode} <br/></> : null}
                    {item.serviceDesc && (
                     `Desc : ${item.serviceDesc}`
                    )}
                    {item.notes ?<>Notes : {item.notes} <br></br></> :null}
                    <div style={{}}>
                    </div>
                    {
                        item.attrs && Object.keys(item.attrs).length > 0 &&
                            item.attrs["lineItemReferenceNo"] ?
                            <p>Line Item Reference No : {item.attrs["lineItemReferenceNo"]}</p> : <></>
                    }
                    {
                        item.attrs && Object.keys(item.attrs).length > 0 &&
                            item.attrs["SO Number"] ?
                            <p>SO No : {item.attrs["SO Number"]}</p> : <></>
                    }
                    {
                        item.attrs && Object.keys(item.attrs).length > 0 &&
                            item.attrs["seven-segment"] ?
                            <p>Seven-segment : {item.attrs["seven-segment"]}</p> : <></>
                    }
                    {
                        item.attrs && Object.keys(item.attrs).length > 0 &&
                        item.attrs["tds_automation"] ?
                            <p>TDS Automation : {item.attrs["tds_automation"]}</p> : <></>
                    }
                    {item.forms && item.forms.length > 0 ? (
					<div>
				      <div 
					     style={{paddingTop:5,cursor: 'pointer'}}
					      onClick={() => setShowCustomFormId(showCustomFormId && showCustomFormId === item.id ? false : item.id)}>
						<h4>
						{showCustomFormId === item.id ? 'Hide': 'Show'}Custom form</h4>
				    	</div> <br />
                         {showCustomFormId === item.id &&
                            sortAndMapForms(item.forms).map((e) => (
                                <div style={{ flexDirection: 'column' }} key={e.key}>
                                    <p style={{fontWeight:250,color:'grey'}}> {e.displayKey}: <span style={{fontWeight:500,color:'black'}}>{e.value}</span></p>
                                    <br />
                                </div>
                            ))
                        }
					</div>
				    ) : null}
                    {
                        (item && item.poInvoiceMismatchReason && ["dtc","DTDC12"].includes(tenant)) ?<div
                            className='ml1'
                            style={{ textAlign: 'center', cursor: 'pointer', color: 'red', fontWeight: '500', fontSize: '11px', border: '1px solid red', borderRadius: '4px', padding: '3px 4px', marginTop: '3px' }}
                            onClick={() => {
                                setShow3WayMatchingMismatch(item.poInvoiceMismatchReason)
                            }}>
                            View 3 way matching mismatch
                        </div> : <></>
                    }
                    {item.serviceAttrs && _.size(item.serviceAttrs) > 0 ? (
                            <div>
                                <div className='mt2'
                                    style={{ fontSize: 13, fontWeight: '700', cursor: 'pointer' }}
                                    onClick={() => setShowServiceCustomFormId(showServiceCustomFormId && showServiceCustomFormId === item.id ? false : item.id)}>
                                    <p> {showServiceCustomFormId === item.id ? 'Hide' : "Show Service Tags"}</p>
                                </div>
                                <br />
                                {showServiceCustomFormId === item.id &&
                                    _.keys(item.serviceAttrs).map((e) => (
                                        <div style={{ flexDirection: 'column', marginTop: -10, textAlign: 'left' }} key={e}>
                                            <p style={{ fontWeight: 250, color: 'grey' }}> {e}: <span style={{ fontWeight: 500, color: 'black' }}>{item.serviceAttrs[e]}</span></p>
                                            <br />
                                        </div>
                                    ))}
                            </div>
                        ) : null}
                    </div>

                <div style={{width: '100px',}}>{item.currency? item.currency : ''} {item.price ?numberWithCommas(item.price.toFixed(2)):item.price}</div>
                <div style={{width: '100px',}}> {item.qtty}</div>
                <div style={{width: '100px', textAlign: 'right'}}>{item.currency? item.currency : ''}  {item.amount ?numberWithCommas(item.amount.toFixed(2)):numberWithCommas(item.amount)} </div>
                <div style={{width: '100px', textAlign: 'right'}}>
               { (invoiceStatus ==='APPROVAL' || (invoiceStatus === 'DRAFT' && allowInvoiceAddLineItemAtDraft)) && !exclude &&
                <span  style={{padding:5,color:'var(--primary-color)',cursor:'pointer'}}
                   onClick={() => setEdit(item)}>
                    EDIT
                </span>}
               {((invoiceStatus ==='APPROVAL' || (invoiceStatus === 'DRAFT' && allowInvoiceAddLineItemAtDraft)) && !exclude && enableLineItemPlugin)&&
                <span  style={{padding:5,color:'var(--red-color)',cursor:'pointer',}}
                   onClick={() => setRemove(item)}>
                    Remove
                </span>}
                </div>
            </div>
        )
    }



    return (
        <div className='FadeRight-Effect' style={{width: '100%', fontSize: '12px'}}>
            <div style={{textAlign: 'center', fontSize: '22px', fontWeight: 'bold'}}>INVOICE</div>
            {
              (props && props.data && (props.data.rcInvoice ||props.data.rcVendor))?
                 <p style={{
                     top:85,
                     left:0,
                     padding:'12px 30px',
                     position:'absolute',
                     background:'var(--primary-color)',
                     color:'var(--white-color)',
                     fontSize:11
                 }}>
                   RCM INVOICE
                 </p>:null
            }
            <div style={{
                border: '1px solid var(--border-color)',
                padding: '20px',
                borderRadius: '15px',
                marginTop: '30px'
            }}>
                <div style={{display: 'flex', justifyContent: 'space-between'}}>
                    <div>
                        <b>Vendor</b><br/>
                        {props.data.vendor}<br/>
                        Email: {props.data.email}<br/>
                        {
                            (vendorDetails && vendorDetails.bank && Object.keys(vendorDetails.bank).length) ?
                                Object.keys(vendorDetails.bank).filter((key)=>key==='account' || key==='bankName' || key==='branchName' || key==='ifsc' || key==='name').map((key)=>{
                                    if(key==='ifsc' && vendorDetails && vendorDetails.customTags && vendorDetails.customTags!=="INR"){
                                       return <div>
                                            Swift Code : {vendorDetails.bank[key]}
                                        </div>
                                    }
                                    return(
                                        <div>
                                            {key} : {vendorDetails.bank[key]}
                                        </div>
                                    )
                                }):null
                        }
                    </div>
                    <div style={{textAlign: 'right'}}>
                        Date: {props.data.date}<br/>
                        {props.data.due?<>Due Date: {moment(props.data.due).format('DD-MM-YYYY')}<br/></>:<></>}
                        Invoice ID: {props.data.Invoice_id}<br/>
                    {props.data.poNumber ? <p style={{ cursor: 'pointer' }} onClick={() => HISTORY.push(`/app/vendor/procurement/order/${props.data.poId}/details`)}>PO Number: {props.data.poNumber}</p> : ''}<br />
                    {props.data && props.data.multiPo && props.data.multiPo.length > 0 ? <>
                         PO Number
                         {props.data.multiPo.map((e) => <p style={{ cursor: 'pointer' }} onClick={() => HISTORY.push(`/app/vendor/procurement/order/${e.id}/details`)}>{e.poId}</p>)}<br />
                     </>
                    : null}
                    {grnNo ? `GRN No : ${grnNo}`: ''}<br/>
                    {props.data.asn ? `ASN: ${props.data.asn.asnId}`: ''}<br/>
                    {props.data.asn ? `ASN Created On: ${moment(props.data.asn.createdAt).format('DD-MM-YYYY')}`: ''}<br/>
                    {props.data.grnNos && props.data.grnNos.length ? `GRN: ${props.data.grnNos.join(",\n")}`: ''}<br/>
                    </div>
                </div>
                <div style={{display: 'flex', justifyContent: 'space-between', marginTop: '20px'}}>
                <div style={{paddingRight: '20px'}}>
                    <b>Billing Address</b><br/>
                    {props.data.bill_add.title?<span>{props.data.bill_add.title}<br></br></span>:null}
                    {props.data.bill_add.registeredName?<span>{props.data.bill_add.registeredName}<br></br></span>:null}
                </div>
                <div style={{textAlign: 'right', paddingLeft: '20px'}}>
                    <b>Shipping Address</b><br/>
                    {props.data.ship_add.title?<span>{props.data.ship_add.title}<br></br></span>:null}
                    {props.data.ship_add.registeredName?<span>{props.data.ship_add.registeredName}<br></br></span>:null}
                </div>
                </div>
            </div>

            <div style={{
                display: 'flex',
                justifyContent: 'space-evenly',
                marginTop: '30px',
                fontWeight: 'bold',
                paddingBottom: '10px',
                borderBottom: '1px solid var(--border-color)'
            }}>
                <div style={{width: '160px'}}>Desciption</div>
                <div style={{width: '100px',}}>Price</div>
                <div style={{width: '100px',}}>Qty</div>
                <div style={{width: '100px', textAlign: 'right'}}>Amount</div>
                <div style={{width: '100px', textAlign: 'right'}}>Actions</div>
            </div>

            {
                props.data.table.map(renderTable)
            }
            {enableAddLineItem && ((status === 'APPROVAL' && !exclude) || (status === 'DRAFT' && allowInvoiceAddLineItemAtDraft && !exclude)) ?
                <p
                    style={{
                        marginTop: 12,
                        color: "var(--primary-color)",
                        fontSize: 13,
                        cursor: "pointer",
                        fontWeight: 600,
                        marginLeft: 1
                    }}
                    onClick={() => {
                        setAddItem(true);
                    }}
                >
                    + Add Line Item
                </p>
                : null
            }
            <div className='invoice-taxes'>
                <div className='wrap'>
                    <div>Base Amt:</div>
                    <div>{props&&props.data&&props.data.currency?props.data.currency:''}  {props.data.base ?(props.data.base).toFixed(2):props.data.base}</div>
                </div>
            </div>
            <div className='invoice-taxes'>
                <div className='wrap'>
                    <div>Discount Amt:</div>
                    <div>{props&&props.data&&props.data.currency?props.data.currency:''}  {props.data.discount?(props.data.discount).toFixed(2):props.data.discount}</div>
                </div>
            </div>
            <div className='invoice-taxes' style={{fontWeight: 'bold'}}>
                <div className='wrap'>
                    <div>Tax Amt:</div>
                    <div> {props&&props.data&&props.data.currency?props.data.currency:''} {(props && props.data && props.data.tax)?props.data.tax.toFixed(2):0}</div>
                </div>
            </div>
            <div className='invoice-taxes'>
                <div className='wrap invoice-summary'>
                    <div className='flex-1'>Total Amt:</div>
                    <div className='flex-1'>{props&&props.data&&props.data.currency?props.data.currency:''}  {props.data.total ?(props.data.total).toFixed(2):props.data.total}</div>
                </div>
            </div>
            {(props && props.data && props.data.tds)?<div className='invoice-taxes'>
                <div className='wrap invoice-summary'>
                    <div className='flex-1'>Total TDS: </div>
                    <div className='flex-1'> {props.data.tds?(props.data.tds.toFixed(2)):(props.data.tds)}</div>
                </div>
            </div>:null}
            {(props && props.data && props.data.payable_amt)?<div className='invoice-taxes'>
                <div className='wrap invoice-summary'>
                    <div className='flex-1'>Total Payable Amount: </div>
                    <div className='flex-1'> {props.data.payable_amt?( `${(props&&props.data&&props.data.currency)?props.data.currency:''} ${props.data.payable_amt.toFixed(2)}`):(`${(props&&props.data&&props.data.currency)?props.data.currency:''} ${props.data.payable_amt}`)}</div>
                </div>
            </div>:null}
            <div className='invoice-taxes'>
                <div className='wrap invoice-summary'>
                    <div className='flex-1'>Base Currency Amt:</div>
                    <div className='flex-1'> {props.data.bill_add?props.data.bill_add.currency:""} {props.data.baseCurrencyAmount ? numberWithCommas(props.data.baseCurrencyAmount):props.data.baseCurrencyAmount}</div>
                </div>
            </div>
            {(props && props.data && props.data.currencyExchangeRate)?<div className='invoice-taxes'>
                <div className='wrap invoice-summary'>
                    <div className='flex-1'>Currency Exchange Rate:</div>
                    <div className='flex-1'>{props.data.currencyExchangeRate}</div>
                </div>
            </div>:null}
            {
                (props && props.data && props.data.rcInvoice) ?
                <div style={{borderTop: '1px solid var(--border-color)'}}>
                    <div className='invoice-taxes'>
                        <div className='wrap invoice-summary'>
                            <div className='flex-1'>Reverse. Charges: </div>
                            <div className='flex-1'>{(props&&props.data&&props.data.currency)?props.data.currency:''} {numberWithCommas((props && props.data && props.data.tax)?props.data.tax.toFixed(2):0)}</div>
                        </div>
                    </div>
                    <div style={{display: 'flex', padding: '10px 0px', fontWeight: 'bold', borderTop: '1px solid var(--border-color)', borderBottom: '1px solid var(--border-color)'}}>
                        <div style={{flexGrow: 1}}>Total Payable Amount: </div>
                        <div style={{width: '100px', textAlign: 'right'}}> {props.data.payable_amt?( `${(props&&props.data&&props.data.currency)?props.data.currency:''} ${(props.data.payable_amt-props.data.tax).toFixed(2)}`):(`${(props&&props.data&&props.data.currency)?props.data.currency:''} ${(props.data.payable_amt-props.data.tax).toFixed(2)}`)}</div>
                    </div>  
                </div>
                :(rcLineItemTax.isRCItem && !props.data.mSettlement.amount) ?
                <div style={{borderTop: '1px solid var(--border-color)'}}>
                    <div className='invoice-taxes'>
                        <div className='wrap invoice-summary'>
                            <div className='flex-1'>Reverse. Charges: </div>
                            <div className='flex-1'>{(props&&props.data&&props.data.currency)?props.data.currency:''} {numberWithCommas(rcLineItemTax.tax.toFixed(2))}</div>
                        </div>
                    </div>
                    <div style={{display: 'flex', padding: '10px 0px', fontWeight: 'bold', borderTop: '1px solid var(--border-color)', borderBottom: '1px solid var(--border-color)'}}>
                        <div style={{flexGrow: 1}}>Total Payable Amount: </div>
                        <div style={{width: '100px', textAlign: 'right'}}>{(props&&props.data&&props.data.currency)?props.data.currency:''} {numberWithCommas(props.data.payable_amt.toFixed(2)- rcLineItemTax.tax.toFixed(2))}</div>
                    </div>
                </div>:null
            }
            
            {edit && (
                <LineItemModal
                details={props.details}
                edit={edit}
                searchProductByService={searchProductByService}
                categoryId={props.data.categoryId}
                onSave={onSaveItem}
                tdsAtLineItem={props.tdsAtLineItem}
                tdsAtLineItemAutomation={(props && props.tdsAtLineItemAutomation)?props.tdsAtLineItemAutomation:undefined}
                tdsAtLineItemInContract={props.tdsAtLineItemInContract}
                vendorId={props.data.vendorId}
                close={() => setEdit(undefined)}
                category={props.data.category}
                contractId={props.data.contractId}
                disableUpdate={disableUpdate}
                tdsSlabs={(props && props.tdsSlabs)?props.tdsSlabs:undefined}
                vendor={(props && props.data && props.data.vendorDetails)?props.data.vendorDetails:undefined}
                />
            )}
            {addItem && (
                <AddLineItem
                    details={props.details}
                    categoryId={props.data.categoryId}
                    vendorId={props.data.vendorId}
                    onSubmit={onAddLineItem}
                    bill_to={props.data.bill_to.title || null}
                    onClose={() => setAddItem(undefined)} 
                    singleLine={props.data.singleLine}
                    tdsSlabs={(props && props.tdsSlabs) ? props.tdsSlabs : undefined}
                    vendor={(props && props.data && props.data.vendorDetails) ? props.data.vendorDetails : undefined}
                />
            )}
            {remove ?
                <Modal
                    buttonName="Remove"
                    onSave={() => {
                        post(`/vendor/invoicing/${systemInvoiceId}/invoiceItem.remove`, {
                            "item_id": remove.id
                        }, (e, r) => {
                            if (r) {
                                post(`vendor/costAllocation/removeAllocation`, { invoiceId: systemInvoiceId }, (e, r) => {
                                    if (r) {
                                        props.onReload()
                                    } else {
                                        props.onReload()
                                    }
                                })
                                showToast({
                                    type: 'success',
                                    message: 'Item Removed successfully'
                                })
                            } else if (e) {
                                handleError(e);
                            }
                            setRemove(null)
                        });

                    }}
                    title={"Remove Line Item"}
                    des=""
                    close={() => {
                        setRemove(null)
                    }}
                    style={{
                        save: {
                            width: '100%',
                            textAlign: 'center',
                            fontSize: 17,
                            background: "var(--red-color)",
                            border: "2px solid var(--red-color)",
                            padding: "12px 20px"
                        },
                    }}
                    show={remove}
                >
                    <div>Are you sure, you want to remove line item?</div>
                </Modal>
                : null}
            {
                show3WayMatchingMismatch?
                <Modal show={true} hideButton={true} title='3 Way Mismatch Reason' des='' close={() =>{setShow3WayMatchingMismatch(false)}}>
                    <div>
                        <p>{show3WayMatchingMismatch}</p>
                    </div>
                </Modal>:null
            }
        </div>
        
    )
}

export default Invoice;
